import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment/moment";
import { Link, Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
    cursor: "pointer",
  },
}));

const NetsuiteCarrierTable = ({ rows, loading, handleView }) => {
  const columns = [
    { id: "name", name: "Carrier Name" },
    { id: "custrecord_wr_carrier_url", name: "Carrier URL" },
    {id:"custrecord_wt_append_url",name:"Carrier Append URL"},
    { id: "lastmodified", name: "Last Modified" },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="netsuite-carrier-table">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <StyledTableCell key={col.id}>{col.name}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No carriers found
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <StyledTableRow
                  key={row.id}
                  onClick={() => handleView(row.nsID, row.name)} // Pass both nsID and name
                >
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.custrecord_wr_carrier_url ? (
                      <Link
                        href={row.custrecord_wr_carrier_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {row.custrecord_wr_carrier_url}
                      </Link>
                    ) : (
                      <Typography color="text.secondary">No URL</Typography>
                    )}
                  </StyledTableCell>
                   <StyledTableCell>
                    {row.custrecord_wt_append_url}
                  </StyledTableCell>
                  <StyledTableCell>
                    {moment(row.lastmodified).format("ddd, MMM Do YYYY, h:mm:ss a")}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default NetsuiteCarrierTable;